import React, { useState } from "react";
import { toast } from "react-toastify";
import api from "../../services/api";
import { renderError } from "../../helpers/errors";
import { convertToCellphone, convertToCep, convertToPhone } from "../../helpers/masks";
import Input from "../Input";
import Button from "../Button";

const formatPhone = digits => digits.length === 11 ? convertToCellphone(digits) : convertToPhone(digits);

export const useCnpjLookup = (value, found) => {
    const [loading, setLoading] = useState(false);

    const lookup = () => {
        if ((value ?? '').replace(/[^0-9A-Za-z]/g, '').length !== 14) {
            toast.error('Informe o CNPJ completo para buscar a empresa.');
            return;
        }

        setLoading(true);

        api.get(`/company/cnpj-lookup`, { params: { cnpj: value } }).then(res => {
            const resource = res.data.resource;

            const changed = found({
                ...resource,
                telefone: formatPhone(resource.telefone ?? ''),
                cep: convertToCep(resource.cep ?? ''),
            });

            if (resource.situacao && resource.situacao !== 'Ativa') {
                toast.warning(`Dados preenchidos, mas a empresa está com situação "${resource.situacao}" na Receita Federal.`);
            } else if (changed === 0) {
                toast.info('Os dados já estavam iguais aos da Receita Federal.');
            } else if (changed > 0) {
                toast.success(`${changed} ${changed === 1 ? 'campo atualizado' : 'campos atualizados'} com os dados da Receita. Confira e salve.`);
            } else {
                toast.success('Dados da empresa preenchidos.');
            }
        }).catch(error => {
            // O renderError redireciona todo 404 para a página de não encontrado.
            if (error.response?.status === 404) {
                toast.error('CNPJ não encontrado na Receita Federal.');
                return;
            }

            if (error.response?.status === 429) {
                toast.error('Muitas buscas em sequência. Tente novamente em instantes.');
                return;
            }

            renderError(error);
        }).then(() => setLoading(false));
    }

    return { lookup, loading };
}

export const InputCnpjLookup = ({value, change, found}) => {
    const { lookup, loading } = useCnpjLookup(value, found);

    return (
        <div className="input-cnpj-lookup">
            <Input type={`text`} label={`CNPJ`} value={value} change={change} mask={`convertToCnpj`} action={lookup} />
            <Button type={`secondary`} svg={`search`} text={`Buscar empresa`} action={lookup} loading={loading} />
        </div>
    );
}

export default InputCnpjLookup;
